"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _modalRender = _interopRequireDefault(require("./modalRender"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO 已经支持从zen-design里取

const useModal = widthContext => {
  const [contextModal, contextHolder] = _antd.Modal.useModal();
  const modalRef = (0, _react.useRef)();
  const open = (0, _react.useCallback)(opts => {
    const {
      width,
      centered,
      zIndex = 1000,
      mask,
      prefixClass = 'zen-design',
      //TODO 写provider时统一改掉
      className,
      style,
      ...renderProps
    } = opts;
    const baseClassName = "".concat(prefixClass, "-modal");
    modalRef.current = (widthContext ? contextModal : _antd.Modal).confirm({
      width,
      className: (0, _classnames.default)(className, baseClassName),
      style,
      centered,
      zIndex,
      mask,
      modalRender: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalRender.default, {
        ...renderProps,
        onClose: () => {
          var _modalRef$current;
          return (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.destroy();
        }
      })
    });
  }, []);
  const close = (0, _react.useCallback)(() => {
    var _modalRef$current2;
    (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 || _modalRef$current2.destroy();
  }, [modalRef.current]);
  const update = (0, _react.useCallback)(opts => {
    var _modalRef$current3;
    const {
      width,
      centered,
      zIndex = 1000,
      mask,
      prefixClass = 'zen-design',
      //TODO 写provider时统一改掉
      className,
      style,
      ...renderProps
    } = opts;
    const baseClassName = "".concat(prefixClass, "-modal");
    (_modalRef$current3 = modalRef.current) === null || _modalRef$current3 === void 0 || _modalRef$current3.update({
      width,
      className: (0, _classnames.default)(className, baseClassName),
      style,
      centered,
      zIndex,
      mask,
      modalRender: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalRender.default, {
        ...renderProps,
        onClose: () => {
          var _modalRef$current4;
          return (_modalRef$current4 = modalRef.current) === null || _modalRef$current4 === void 0 ? void 0 : _modalRef$current4.destroy();
        }
      })
    });
  }, [modalRef.current]);
  return [{
    open,
    close,
    update
  }, widthContext ? contextHolder : undefined];
};
var _default = exports.default = useModal;